(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/start-page/assets/javascripts/start-page.js') >= 0) return;  svs.modules.push('/modules/start-page/assets/javascripts/start-page.js');
"use strict";


(function (_, svs) {
  'use strict';

  svs.modules = svs.modules || {};

  const renderAppPromo = () => {
    const appPromo = new svs.components.AppPromo({
      storageKey: 'se.svenskaspel.spelbutiken',
      message: 'Upptäck fördelarna med att spela i vår app - få notiser om spelstopp och avslutade dragningar. ' + '<a href="https://play.google.com/store/apps/details?id=se.svenskaspel.tur&hl=sv" target="_blank">Ladda ner Tur-appen för Android här.</a>',
      storageExpires: svs.components.Storage.constants.EXPIRES_1MONTH * 6
    });
    appPromo.show();
  };

  const setUpListeners = () => {
    const mainContent = $('#main-content');
    $(mainContent).on('click', '.js-open-login-button', e => {
      Boolean(e) && e.preventDefault();
      svs.components.customer_login.login();
    });
  };
  let isBottomSheetDoubleClick = false;
  const trackAndNavigate = _ref => {
    let {
      path,
      isLogin
    } = _ref;
    if (isBottomSheetDoubleClick) {
      return;
    }
    let action = 'Bli kund';
    if (isLogin) {
      action = 'Logga in';
    }
    isBottomSheetDoubleClick = true;
    const track = {
      category: 'bottom sheet',
      action,
      opt_label: action
    };
    svs.components.analytics.trackEvent(track, () => {
      isBottomSheetDoubleClick = false;
      location.href = path;
    });
  };
  const renderBottomsheet = () => {
    const btn = svs.ui.button.partials.button({
      class: 'js-login-button-bottom-sheet',
      focus: true,
      block: true,
      content: 'Logga in'
    });
    const content = "\n    <div class=\"f-center padding-xs-bottom-1 padding-xs-h-2 padding-xs-top-2\">".concat(btn, "</div>\n    <div class=\"f-center padding-xs-bottom-2\">\n      <a class=\"js-registration-link-bottom-sheet fc-navy u-text-decoration-underline\">Bli kund</a>\n    </div>");
    const bottomSheet = new svs.ui.BottomSheet({
      classNames: 'bg-tur-100',
      transparent: true,
      isFixed: true,
      footerContent: content
    });
    bottomSheet.show();
    document.querySelector('.js-login-button-bottom-sheet').addEventListener('click', () => {
      trackAndNavigate({
        path: svs.core.urlMapping.get('loginHome'),
        isLogin: true
      });
    });
    document.querySelector('.js-registration-link-bottom-sheet').addEventListener('click', () => {
      trackAndNavigate({
        path: svs.core.urlMapping.get('customerRegistrationHome'),
        isLogin: false
      });
    });
  };

  $(document).ready(() => {
    setUpListeners();
    renderAppPromo();
    if (svs.core.detect.formfactor.mobile() && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      renderBottomsheet();
    }
    if (Modernizr.history && history.state && history.state.type && history.state.type === 'modal') {
      history.back();
    }
  });
})(_, svs);

 })(window);